const RequestType = Object.freeze({
  GET: 'GET',
  POST: 'POST',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
});

export default RequestType;
